module.exports = __webpack_public_path__ + "profile-3-m-dww.png";